import { createSlice, createSelector } from '@reduxjs/toolkit';

const initialState = {

    tablePersonne: [],
    detailPersonne: {},
    InfosRegimeObligatoire: {},
    contrat: {},
    contratsBeneficiaires: [],
    infosComplementaires: {},
    idPersGrc: null,
    demandeAcit: {
        idPersGrc: null
    },
}

const gestionContratSlice = createSlice({
    name: "gestionContrat",
    initialState,
    reducers: {
        clearGestionContrat(state, action) {
            return {
                ...state,
                tablePersonne: [],
                detailPersonne: {},
                InfosRegimeObligatoire: {},
                contrat: {},
                contratsBeneficiaires: [],
                infosComplementaires: {},
                idPersGrc: null,
                demandeAcit: {
                    idPersGrc: null
                },
            }
        },
        clearTablePersonne(state, action) {
            return {
                ...state,
                tablePersonne: []
            }
        },
        updateTablePersonne(state, action) {
            return {
                ...state,
                tablePersonne: action?.payload
            }
        },
        clearDetailPersonne(state, action) {
            return {
                ...state,
                detailPersonne: []
            }
        },
        updateDetailPersonne(state, action) {
            return {
                ...state,
                detailPersonne: action?.payload
            }
        },
         updateInfosRegimeObligatoire(state, action) {
            return {
                ...state,
                InfosRegimeObligatoire: action?.payload
            }
        },
        clearContratsBeneficiaires(state, action) {
            return {
                ...state,
                contratsBeneficiaires: []
            }
        },
        updateContratsBeneficiaires(state, action) {
            return {
                ...state,
                contratsBeneficiaires: action?.payload
            }
        },
        updateContrat(state, action) {
            return {
                ...state,
                contrat: action?.payload
            }
        },
        clearInfosComplementaires(state, action) {
            return {
                ...state,
                infosComplementaires: {}
            }
        },
        updateInfosComplementaires(state, action) {
            return {
                ...state,
                infosComplementaires: action?.payload
            }
        },
        updateIdPersGrc(state, action) {
            return {
                ...state,
                idPersGrc: action?.payload
            }
        },
        updateDemandeAcit(state, action) {
            return {
                ...state,
                demandeAcit: action?.payload,
            }
        },
    }
})

export const {
    clearGestionContrat,
    clearTablePersonne,
    updateTablePersonne,
    clearDetailPersonne,
    updateDetailPersonne,
    updateInfosRegimeObligatoire,
    updateContrat,
    clearContratsBeneficiaires,
    updateContratsBeneficiaires,
    clearInfosComplementaires,
    updateInfosComplementaires,
    updateIdPersGrc,
    updateDemandeAcit,
} = gestionContratSlice.actions

export default gestionContratSlice.reducer